var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"headers-col br"},[_c('simulation-main-badge-header'),_vm._v(" "),_c('simulation-table',{attrs:{"draggable":_vm.store.isShownAvailableProducts},on:{"dragEnd":_vm.onDragEnd},scopedSlots:_vm._u([{key:"default",fn:function({dataElement, isSubheader}){return [_c('span',{staticClass:"text-start",class:{
              'font-weight-medium': !isSubheader,
              'pl-8': isSubheader,
            }},[_vm._v("\n          "+_vm._s(dataElement.header())+"\n        ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }